const TJLS_HOME_BG = require('@/assets/images/tjls/home.jpg')
const DEFAULT_HOME_BG = require('@/assets/images/background.png')

const preloaded = new Set()

export function getHomeBackgroundUrl(tenantId) {
  return tenantId === 133 ? TJLS_HOME_BG : DEFAULT_HOME_BG
}

export function preloadHomeBackground(tenantId) {
  const url = getHomeBackgroundUrl(tenantId)
  if (preloaded.has(url)) {
    return
  }
  preloaded.add(url)
  const img = new Image()
  img.src = url
}
